






















import {Component, Vue} from 'vue-property-decorator';
import LocaleChanger from '@/components/LocaleChanger.vue';
import {preload} from '@/util';

@Component({
  components: {
    LocaleChanger,
  },
})
export default class Survey extends Vue {
  private name: string = '';
  private age: number | null = null;

  private created() {
    this.$store.dispatch('setSurveyUuid', this.$route.params.uuid)
      .catch(() => this.$router.push('/error'));
  }

  private startSurvey(event: Event) {
    event.preventDefault();

    this.$store.dispatch('createSubmission', {name: this.name, age: this.age})
      .then(() => this.$router.push('/intro-practise'))
      .then(() => preload(this.images))
      .catch(() => this.$router.push('/error'));
  }

  private get images() {
    const images = [
      ...this.$store.getters.practiseImages,
      ...this.$store.getters.shortImages,
      ...this.$store.getters.longImages,
    ];

    return images.map((i: any) => {
      if (i.image.image.startsWith('http')) {
        return i.image.image;
      } else {
        return `${process.env.VUE_APP_IMG_PATH}/${i.image.image}`;
      }
    });
  }
}
